import { Component, Input, OnDestroy } from '@angular/core';
import { API } from '../../../types.api';
import { TranslatorService } from '../../../services/translator_service';
import { ApiQuery } from '../../../web-services/api/api.query';
import { ResponsiveService } from '../../../services/responsive.service';
import { CommonModule } from '@angular/common';
import { RTLDivDirectiveDirective } from '../../../directives/rtldiv-directive.directive';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { GoogleMapsModule } from '@angular/google-maps'
import { UtilService } from '../../../services/util.service';
import moment from 'moment';
import { ApiService } from '../../../web-services/api/api.service';
import { ApiStore } from '../../../web-services/api/api.store';
import { FormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-bin-location-description',
  imports: [CommonModule,TranslatePipe,RTLDivDirectiveDirective,MatCardModule,MatDividerModule,GoogleMapsModule,
    NgbTooltipModule,FormsModule],  
  templateUrl: './bin-location-description.html',
  styleUrl: './bin-location-description.scss',
})
export class BinLocationDescription implements OnDestroy {
  isMobile: boolean = false;
  expectedApprovalAddress: string = '';
	@Input() orientation: boolean;
	binInfo;
	@Input()
	set binLiveInfo_Bin(bin_info:any) {	
		if(bin_info != null){
			this.binInfo = bin_info;
			this.clearLocationHistoryMarkers();
			this.clearLocationHistoryPolylines();
			this.showLocationHistory = false;
			this.gpsLocationHistory = [];
			this.displayGpsApproval = false;
			this.expectedApprovalItem = null;
			this.expectedApprovalAddress = '';
			this.subscribeBinInfo(this.binInfo);
		}
	}
	private readonly destroy$ = new Subject<void>();
	user_role_id = 0;
	gpsLocationHistory: any[] = [];
	locationHistoryPolylines: google.maps.Polyline[] = [];
	locationHistoryMarkers: google.maps.Marker[] = [];
	showLocationHistory: boolean = false;
	displayGpsApproval: boolean = false;
	displaySuccessAction: boolean = false;
	displayRejectAction: boolean = false;
	displayTheSameLocationAction: boolean = false;
	expectedApprovalItem: any = null;
	binData: API.Bin;
	map: any = null;
	gpsRequested: boolean = false;
	binName;
	binId;
	marker;
	openedInfoWindow = [];
	currentLang;
	translationsObj;
	translate;
	usageType = 1;
  mapOptions: google.maps.MapOptions = {
    clickableIcons: false,
    streetViewControl : false,
    fullscreenControl : true,
    mapTypeControl : true
  };
  mobileMapOptions: google.maps.MapOptions = {
    streetViewControl: true,
    mapTypeControl : false,
    clickableIcons : false,
    fullscreenControl : true
  };


	constructor(private translator: TranslatorService,private apiQuery:ApiQuery,private utilService: UtilService,
		private responsiveService: ResponsiveService,private apiService:ApiService,private apiStore:ApiStore) {
			this.translate = this.translator;
			this.translator.currentLangEmitter$
			.pipe(takeUntil(this.destroy$))
			.subscribe(async value=>{						
			  this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
			  this.currentLang = value;	
			})
	}

	ngOnInit() {
		this.onResize();
		this.responsiveService.checkWidth();
		this.binName = '';
		this.binId = '';
		this.binData = null;
		this.apiQuery.user$.pipe(takeUntil(this.destroy$)).subscribe(user => {
			if (!user) {
				return;
			}						
			if(user["usage_type_id"] != 1){
				this.usageType = user["usage_type_id"];
			}	
			this.user_role_id = user["user_role_id"];
		});
	}

	onResize() {
		this.responsiveService.getMobileStatus().pipe(takeUntil(this.destroy$)).subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	  }

	private subscribeBinInfo = (bin: API.Bin) => {
		if (!bin) return;
		this.binData = bin;
		this.gpsRequested = this.binData?.['Bin_live_Data']?.['gps_status_id'] > 0;
		if(bin){
			const dataToSend = {
				"bin_id" : this.binData.bin_id
			};
			this.apiService.getBinGpsLocationHistory(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((response:any) => {
				if(response.GpsHistoryObj == null){
					this.gpsRequested = false;
				}else if(response.GpsHistoryObj?.length > 0){
					this.gpsLocationHistory = response.GpsHistoryObj;
					//get the last item in the array
					const lastItem = this.gpsLocationHistory[this.gpsLocationHistory.length - 1];
					if(lastItem.request_status == 1 || lastItem.request_status == 2){
						this.gpsRequested = true;
					}else if(lastItem.request_status == 3){
						const sameCoords =
							lastItem.bin_lat == this.binData['Bin_location'].bin_latitude &&
							lastItem.bin_lon == this.binData['Bin_location'].bin_longitude;
							if(sameCoords){
								this.gpsRequested = false;
								this.displayTheSameLocationAction = true;
							}else{
								this.gpsRequested = true;
							}
					}else if(lastItem.request_status == 4 || lastItem.request_status == 5){
						this.gpsRequested = false;
					}
					this.displayGpsApproval = this.shouldDisplayGpsApproval(this.gpsLocationHistory);
					let expectedApprovalItemIndex = [...this.gpsLocationHistory].map(item => item.request_status).lastIndexOf(3);
					this.expectedApprovalItem = this.gpsLocationHistory[expectedApprovalItemIndex];
					
					if (this.expectedApprovalItem && this.expectedApprovalItem.bin_lat && this.expectedApprovalItem.bin_lon) {
						this.getAddressFromCoordinates(
							Number(this.expectedApprovalItem.bin_lat),
							Number(this.expectedApprovalItem.bin_lon)
						);
					}
					if (this.displayGpsApproval) {
						this.showLocationHistory = true;
						this.onShowLocationHistoryChange();
					}
				}
			});				
		}
		const location = {
			lat: this.binData.Bin_location.bin_latitude,
			lng: this.binData.Bin_location.bin_longitude
		};
		this.binName = this.binData.bin_name;
		this.binId = this.binData.bin_id;
		this.loadAPIWrapperInternal(this.map, location);
	}

	getAddressFromCoordinates(latitude: number, longitude: number) {
		const geocoder = new google.maps.Geocoder();
		const latlng = {
			lat: latitude,
			lng: longitude
		};

		// Set language based on currentLang
		const language = this.currentLang === 'iw' ? 'he' : 'en';

		geocoder.geocode(
			{ 
				location: latlng,
				language: language
			},
			(
				results: google.maps.GeocoderResult[],
				status: google.maps.GeocoderStatus
			) => {
				if (status === 'OK') {
					if (results[0]) {
						this.expectedApprovalAddress = results[0].formatted_address;
					} else {
						this.expectedApprovalAddress = '';
					}
				} else {
					this.expectedApprovalAddress = '';
				}
			}
		);
	}

	shouldDisplayGpsApproval(responseItems) {
		const lastStatus3Index = [...responseItems]
		  .map(item => item.request_status)
		  .lastIndexOf(3);

		if (lastStatus3Index === -1) {
		  return false;
		}

		const lastStatus3Item = responseItems[lastStatus3Index];

		// Same coordinates as selected bin → do not display
		const sameCoords =
		  lastStatus3Item.bin_lat == this.binData['Bin_location'].bin_latitude &&
		  lastStatus3Item.bin_lon == this.binData['Bin_location'].bin_longitude;
	  
		if (sameCoords) {
		  return false;
		}
	  
		// If the item still has status 3, it hasn't been approved/rejected yet
		// The same object changes request_status to 4/5 when approve/reject
		return lastStatus3Item.request_status == 3;
	}

	onShowLocationHistoryChange = () => {
		if (this.showLocationHistory) {
			this.displayLocationHistory();
		} else {
			this.clearLocationHistoryMarkers();
			this.clearLocationHistoryPolylines();
		}
	}

	clearLocationHistoryMarkers = () => {
		this.locationHistoryMarkers.forEach(marker => {
			marker.setMap(null);
		});
		this.locationHistoryMarkers = [];
	}

	clearLocationHistoryPolylines = () => {
		this.locationHistoryPolylines.forEach(polyline => {
			polyline.setMap(null);
		});
		this.locationHistoryPolylines = [];
	}

	ngOnDestroy(): void {
		this.destroy$.next();
		this.destroy$.complete();
	}

	displayLocationHistory = () => {
		if (!this.map || !this.binData || !this.gpsLocationHistory || this.gpsLocationHistory.length === 0) {
			return;
		}

		// Clear existing markers and polylines
		this.clearLocationHistoryMarkers();
		this.clearLocationHistoryPolylines();

		// Get all items with request_status == 4
		const status4Items = this.gpsLocationHistory.filter(item => item.request_status == 4);
		const status3Items = this.gpsLocationHistory.filter(item => item.request_status == 3);

		// if (status4Items.length == 0) {
		// 	return;
		// }

		// Get the last item with request_status == 3
		const lastStatus3Item = status3Items[status3Items.length - 1];
		// Get all status 4 items except the last one (for grey markers) because it has the same coordinates as the bin
		const greyMarkersItems = status4Items.slice(0, -1).filter(item => Number(item.bin_lat) != 0 && Number(item.bin_lon) != 0);
		// Add grey markers for all status 4 items 
		greyMarkersItems.forEach(item => {
			if (item.bin_lat && item.bin_lon) {
				const marker = new google.maps.Marker({
					position: {
						lat: Number(item.bin_lat),
						lng: Number(item.bin_lon)
					},
					map: this.map,
					icon: '../../assets/images/bins/all/past_status.svg'
				});
				this.locationHistoryMarkers.push(marker);
			}
		});
		// Add green marker for selectedBinInfo location
		const selectedBinLat = Number(this.binData['Bin_location']?.bin_latitude);
		const selectedBinLng = Number(this.binData['Bin_location']?.bin_longitude);
		
		if (selectedBinLat!=null && selectedBinLng!=null) {
			const selectedBinMarker = new google.maps.Marker({
				position: {
					lat: selectedBinLat,
					lng: selectedBinLng
				},
				map: this.map,
				icon: '../../assets/images/bins/all/current_status.svg'
			});
			this.locationHistoryMarkers.push(selectedBinMarker);
		}

		// Add green marker with question mark for the last object from getBinGpsLocationHistory
		if (lastStatus3Item && lastStatus3Item.bin_lat && lastStatus3Item.bin_lon) {
			const lastItemMarker = new google.maps.Marker({
				position: {
					lat: Number(lastStatus3Item.bin_lat),
					lng: Number(lastStatus3Item.bin_lon)
				},
				map: this.map,
				icon: '../../assets/images/bins/all/approved_status.svg'
			});
			this.locationHistoryMarkers.push(lastItemMarker);

			// Add green arrow from selectedBinInfo marker to question mark marker
			if (selectedBinLat!=null && selectedBinLng!=null) {
				const greenArrow = new google.maps.Polyline({
					path: [
						{ lat: selectedBinLat, lng: selectedBinLng },
						{ lat: Number(lastStatus3Item.bin_lat), lng: Number(lastStatus3Item.bin_lon) }
					],
					geodesic: true,
					strokeColor: '#006EEF',
					strokeOpacity: 0,
					strokeWeight: 1,
					map: this.map,
					icons: [{
						icon: {
							path: 'M -2,-2 L 2,-2 L 2,2 L -2,2 Z',
							strokeColor: '#006EEF',
							fillColor: '#006EEF',
							fillOpacity: 1,
							strokeOpacity: 1,
							strokeWeight: 1
						},
						offset: '0%',
						repeat: '12px'
					}, {
						icon: {
							path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
							scale: 3.5,
							strokeColor: '#006EEF',
							strokeWeight: 1,
							fillColor: '#006EEF',
							fillOpacity: 1
						},
						offset: '100%'
					}]
				});
				this.locationHistoryPolylines.push(greenArrow);
			}
		}

		// Connect grey markers in sequence
		for (let i = 0; i < greyMarkersItems.length - 1; i++) {
			const currentItem = greyMarkersItems[i];
			const nextItem = greyMarkersItems[i + 1];
			
			if (currentItem.bin_lat && currentItem.bin_lon && nextItem.bin_lat && nextItem.bin_lon) {
				const blackArrow = new google.maps.Polyline({
					path: [
						{ lat: Number(currentItem.bin_lat), lng: Number(currentItem.bin_lon) },
						{ lat: Number(nextItem.bin_lat), lng: Number(nextItem.bin_lon) }
					],
					geodesic: true,
					strokeColor: '#68747A',
					strokeOpacity: 0,
					strokeWeight: 1,
					map: this.map,
					icons: [{
						icon: {
							path: 'M -2,-2 L 2,-2 L 2,2 L -2,2 Z',
							strokeColor: '#68747A',
							fillColor: '#68747A',
							fillOpacity: 1,
							strokeOpacity: 1,
							strokeWeight: 1
						},
						offset: '0%',
						repeat: '12px'
					}, {
						icon: {
							path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
							scale: 3.5,
							strokeColor: '#68747A',
							strokeWeight: 1,
							fillColor: '#68747A',
							fillOpacity: 1
						},
						offset: '100%'
					}]
				});
				this.locationHistoryPolylines.push(blackArrow);
			}
		}

		// Connect last grey marker to selectedBinInfo marker (if exists)
		if (greyMarkersItems.length > 0) {
			const lastGreyItem = greyMarkersItems[greyMarkersItems.length - 1];
			if (lastGreyItem.bin_lat && lastGreyItem.bin_lon && selectedBinLat!=null && selectedBinLng!=null) {
				const blackArrow = new google.maps.Polyline({
					path: [
						{ lat: Number(lastGreyItem.bin_lat), lng: Number(lastGreyItem.bin_lon) },
						{ lat: selectedBinLat, lng: selectedBinLng }
					],
					geodesic: true,
					strokeColor: '#68747A',
					strokeOpacity: 0,
					strokeWeight: 1,
					map: this.map,
					icons: [{
						icon: {
							path: 'M -2,-2 L 2,-2 L 2,2 L -2,2 Z',
							strokeColor: '#68747A',
							fillColor: '#68747A',
							fillOpacity: 1,
							strokeOpacity: 1,
							strokeWeight: 1
						},
						offset: '0%',
						repeat: '12px'
					}, {
						icon: {
							path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
							scale: 3.5,
							strokeColor: '#68747A',
							strokeWeight: 1,
							fillColor: '#68747A',
							fillOpacity: 1
						},
						offset: '100%'
					}]
				});
				this.locationHistoryPolylines.push(blackArrow);
			}
		}
	}

	approveGpsResponse(){
		const items_with_status_3 = this.gpsLocationHistory.filter(item => item.request_status == 3);
		const lastStatus3Item = items_with_status_3[items_with_status_3.length - 1];

		const dataToSend = {
			"request_status": 4,	
			"request_index": lastStatus3Item.request_index 	
		};
		this.apiService.setBinsGpsCoordinates(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {
			this.displaySuccessAction = true;
			const dataToSend = {
				"bin_id_list" : [[Number(this.binData.bin_id),Number(this.binData.cluster_id)]],
				"address": this.expectedApprovalAddress
			};
			this.apiService.setBinThresholdsAndRestrictions(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {
				this.apiService.getBinInfo(this.binData.bin_id);
				this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
				this.apiStore.update({ allFilteredBasicBins: [] });                    
				this.apiStore.update({ filteredBasicBins: [] }); 
				this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
			});
		});
	}

	rejectGpsResponse(){
		const items_with_status_3 = this.gpsLocationHistory.filter(item => item.request_status == 3);
		const lastStatus3Item = items_with_status_3[items_with_status_3.length - 1];

		const dataToSend = {
			"request_status": 5,
			"request_index": lastStatus3Item.request_index 	
		};
		this.apiService.setBinsGpsCoordinates(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {
			this.displayRejectAction = true;
			this.apiService.getBinInfo(this.binData.bin_id);
			this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
			this.apiStore.update({ allFilteredBasicBins: [] });                    
			this.apiStore.update({ filteredBasicBins: [] }); 
			this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
		});
	}

	public loadAPIWrapper(map: any) {
		this.map = map;
		if(!this.isMobile){
			this.addYourLocationButton(this.map);
		}
		this.loadAPIWrapperInternal(this.map, null);
	}

	calcDiff = (date: string) => {
		if (this.translationsObj != undefined) {
			let diff_in_string = '';
			const original_date = moment(date);
			const date_time_now = moment();
			const diff_in_object: any = this.utilService.preciseDiffBetweenDates(original_date, date_time_now, true);
			if (diff_in_object.months > 0) {
				diff_in_string = diff_in_string + diff_in_object.months + ' ';
				if (diff_in_object.months === 1) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.MONTH + ' ';
				} else {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.MONTHS + ' ';
				}
			}
			if (diff_in_object.days > 0) {
				diff_in_string = diff_in_string + diff_in_object.days + ' ';
				if (diff_in_object.days === 1) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.DAY + ' ';
				} else {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.DAYS + ' ';
				}
			}
			if (diff_in_object.hours > 0) {
				if (diff_in_object.days > 0) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.hours + ' ';
				} else {
					diff_in_string += diff_in_object.hours + ' ';
				}
				if (diff_in_object.hours === 1) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.HOUR + ' ';
				} else {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.HOURS + ' ';
				}
			}
			
			if (diff_in_object.minutes > 0) {
				if (diff_in_object.hours > 0) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.AND + ' ' + diff_in_object.minutes + ' ';
				} else {
					diff_in_string += diff_in_object.minutes + ' ';
				}
				if (diff_in_object.minutes === 1) {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.MINUTE + ' ';
				} else {
					diff_in_string += this.translationsObj.COLLECTION_REPORT.MINUTES + ' ';
				}
			}
			else {
				diff_in_string += this.translationsObj.COLLECTION_REPORT.MINUTE + ' ';
			}

			if (this.currentLang !== 'iw') {
				diff_in_string += this.translationsObj.COLLECTION_REPORT.AGO;
			}
			else {
				diff_in_string = this.translationsObj.COLLECTION_REPORT.AGO + ' ' + diff_in_string;
			}
			return diff_in_string;
		}	
	}

	addYourLocationButton(map) {
		let controlDiv = document.createElement('div');
		let firstChild = document.createElement('button');
		firstChild.type = 'button';
		firstChild.style.backgroundColor = '#fff';
		firstChild.style.border = 'none';
		firstChild.style.outline = 'none';
		firstChild.style.width = '40px';
		firstChild.style.height = '40px';
		firstChild.style.borderRadius = '2px';
		firstChild.style.boxShadow = '0 1px 4px rgba(0,0,0,0.3)';
		firstChild.style.cursor = 'pointer';
		firstChild.style.marginRight = '10px';
		firstChild.style.padding = '0px';
		firstChild.title = 'Your Location';
		controlDiv.appendChild(firstChild);
		
		let secondChild = document.createElement('div');
		secondChild.style.margin = 'calc(50% - 18px / 2)';
		secondChild.style.width = '18px';
		secondChild.style.height = '18px';
		secondChild.style.backgroundImage = 'url(https://maps.gstatic.com/tactile/mylocation/mylocation-sprite-1x.png)';
		secondChild.style.backgroundSize = '180px 18px';
		secondChild.style.backgroundPosition = '0px 0px';
		secondChild.style.backgroundRepeat = 'no-repeat';
		secondChild.id = 'center-bininfo';
		firstChild.appendChild(secondChild);
		
		google.maps.event.addListener(map, 'dragend', function() {
			document.getElementById('center-bininfo').style.backgroundPosition = '0px 0px';
		});

		firstChild.addEventListener('click', function() {
			var imgX = '0';
			var animationInterval = setInterval(function(){
				if(imgX == '-18') imgX = '0';
				else imgX = '-18';
				document.getElementById('center-bininfo').style.backgroundPosition = imgX+'px 0px';
			}, 500);
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition( pos => {        
				map.setCenter({lat: pos.coords.latitude, lng: pos.coords.longitude});
				map.setZoom(15);
				clearInterval(animationInterval);
				document.getElementById('center-bininfo').style.backgroundPosition = '-144px 0px';
				}, error => {
				},{maximumAge:10000, timeout:5000, enableHighAccuracy: true});
			}else{
				clearInterval(animationInterval);
				document.getElementById('center-bininfo').style.backgroundPosition = '0px 0px';
			}
		});
		map.controls[google.maps.ControlPosition.RIGHT_BOTTOM].push(controlDiv);
	}

	requestGpsSync(){
		if(this.gpsRequested){
			return;
		}
		this.gpsRequested = true;
		const dataToSend = {
			"is_gps_enabled" : "1",
			"bin_id_list" : [[Number(this.binData.bin_id),Number(this.binData.cluster_id)]]			
		};
		this.apiService.setBinThresholdsAndRestrictions(dataToSend).pipe(takeUntil(this.destroy$)).subscribe((v:any) => {
			this.apiService.getBinInfo(this.binData.bin_id);
			this.apiService.getfilteredBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
			this.apiStore.update({ allFilteredBasicBins: [] });                    
			this.apiStore.update({ filteredBasicBins: [] }); 
			this.apiService.getfilteredBasicBinsInfo(JSON.parse(sessionStorage.getItem("chosenSites")));
		});
	}

	private loadAPIWrapperInternal(map: any, customLocation: any) {
		if (!map || !this.binData || !this.binData.Bin_location) { return; }
		const userPosition = {
			lat: 32.085300,
			lng: 34.781768
		};
		if (customLocation) {
			userPosition.lat = customLocation.lat;
			userPosition.lng = customLocation.lng;
		}
		this.map.panTo(userPosition);
		this.map.setZoom(12);
		this.addMarker(map);
	}

	private addMarker = (map: any) => {
		this.clearMarkers();
		const icon = this.BinToIcon(this.binData.Bin_live_Data.color_status_id);
		this.marker = new google.maps.Marker({
			position: {
				lat: this.binData.Bin_location.bin_latitude,
				lng: this.binData.Bin_location.bin_longitude
			},
			map: map,
			icon: icon
		});
	}

	private clearMarkers = () => {
		if (!this.marker) { return; }
		this.marker.setMap(null);
	}

	private BinToIcon(status: number) {
		let icon = '';
		// if(status == 0){
		// 	icon = `../../assets/images/bins/all/greenNotOrdered.svg`;
		// }else if(status == 1){
		// 	icon = `../../assets/images/bins/all/yellowNotOrdered.svg`;
		// }else if(status == 2){
		// 	icon = `../../assets/images/bins/all/redNotOrdered.svg`;
		// }
		icon = `../../assets/images/bins/all/current_status.svg`;
		return icon;
	}
}
